import {BaseView} from "../core/view";
import {TrackingUtil} from "../utils/tracking";

export default BaseView.extend({

    el: '.js-gender-split',

    events: {
		'click .js-gender-split-button': 'genderSplitButtonClick'
    },

    initialize: function () {
    	if(this.el){
            TrackingUtil.throwGAEvent('Gendersplit', 'View', window.location.pathname, true);
		}
    },

    genderSplitButtonClick: function(e){
        if(this.el){
            let action = "Click." + e.currentTarget.getAttribute('data-gender');
            TrackingUtil.throwGAEvent('Gendersplit', action, window.location.pathname, false);
        }
	}
});